import { z } from "zod";
import { ColumnOptionsSchema, ColumnSchema, ViewSchema } from "./views";

export enum TransactionColumn {
    DATE = "date",
    AMOUNT = "amount",
    DESCRIPTION = "description",
    CATEGORY = "category",
    ACCOUNT = "account",
    COUNTERPARTY = "counterparty",
    NOTE = "note",
    RECEIPTS = "receipts",
    SPLIT = "split",
    CLASSES = "classes",
    ENTITY = "entity",
    ACTIONS = "actions",
    RECEIPT_UPLOAD = "receipt_upload",
    TRANSFER_MATCH = "transfer_match",
}

const DateColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionColumn.DATE),
});
export type DateColumn = z.infer<typeof DateColumnSchema>;

const AmountColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionColumn.AMOUNT),
});
export type AmountColumn = z.infer<typeof AmountColumnSchema>;

const DescriptionColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionColumn.DESCRIPTION),
});
export type DescriptionColumn = z.infer<typeof DescriptionColumnSchema>;

const CategoryColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionColumn.CATEGORY),
    options: ColumnOptionsSchema.extend({
        required: z.boolean().optional(),
    }).optional(),
});
export type CategoryColumn = z.infer<typeof CategoryColumnSchema>;

const AccountColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionColumn.ACCOUNT),
});
export type AccountColumn = z.infer<typeof AccountColumnSchema>;

const CounterpartyColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionColumn.COUNTERPARTY),
});
export type CounterpartyColumn = z.infer<typeof CounterpartyColumnSchema>;

const NoteColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionColumn.NOTE),
});
export type NoteColumn = z.infer<typeof NoteColumnSchema>;

const ReceiptsColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionColumn.RECEIPTS),
});
export type ReceiptsColumn = z.infer<typeof ReceiptsColumnSchema>;

const SplitColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionColumn.SPLIT),
});
export type SplitColumn = z.infer<typeof SplitColumnSchema>;

const ClassesColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionColumn.CLASSES),
});
export type ClassesColumn = z.infer<typeof ClassesColumnSchema>;

const EntityColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionColumn.ENTITY),
});
export type EntityColumn = z.infer<typeof EntityColumnSchema>;

const ReceiptUploadColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionColumn.RECEIPT_UPLOAD),
});
export type ReceiptUploadColumn = z.infer<typeof ReceiptUploadColumnSchema>;

const TransferMatchColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionColumn.TRANSFER_MATCH),
});
export type TransferMatchColumn = z.infer<typeof TransferMatchColumnSchema>;

const ActionsColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionColumn.ACTIONS),
    options: ColumnOptionsSchema.extend({
        requiredActions: z.array(z.string()).optional(),
    }).optional(),
});
export type ActionsColumn = z.infer<typeof ActionsColumnSchema>;

export const TransactionViewSchema = ViewSchema.extend({
    type: z.literal("transaction"),
    columns: z.array(
        z.discriminatedUnion("id", [
            DateColumnSchema,
            AmountColumnSchema,
            DescriptionColumnSchema,
            CategoryColumnSchema,
            AccountColumnSchema,
            CounterpartyColumnSchema,
            NoteColumnSchema,
            ReceiptsColumnSchema,
            SplitColumnSchema,
            ClassesColumnSchema,
            EntityColumnSchema,
            ReceiptUploadColumnSchema,
            TransferMatchColumnSchema,
            ActionsColumnSchema,
        ]),
    ),
});

export type TransactionView = z.infer<typeof TransactionViewSchema>;
